'use client'

import { Annotation, Annotation2 } from '@/types/annotation'
import { Weather } from '@/components/utility/weather'

export const AnnotationWeather: React.FC<{ annotation: Annotation | Annotation2 }> = ({
  annotation
}) => {
  const weatherResult = annotation.webScraper__getWeather
  if (!weatherResult) {
    return null
  }

  const weatherAtLocation = 'result' in weatherResult ? weatherResult.result : weatherResult

  if (!weatherAtLocation) {
    return null
  }

  return (
    <div className="space-y-4 p-4">
      <Weather weatherAtLocation={weatherAtLocation} />
    </div>
  )
}

// Rename the export to match the import
export { AnnotationWeather as Weather }
